import moment from 'moment-timezone'

export const processInstance = (i) => {
  const processed = {
    id: i.id,
    extId: i.ext_id,
    adminUsername: i.admin_username,
  }
  return processed
}

export const processSource = (s) => {
  const processed = {
    id: s.id,
    extId: s.ext_id,
    name: s.name,
    type: s.type,
    lastImportTime: s.last_import_time,
    state: s.state || '',
    error: s.error || '',
    url: s.url || '',
    inputFtpStorage: s.input_ftp_storage || '',
    outputFtpStorage: s.output_ftp_storage || '',
    total: 0,
    video: 0,
    transcoded: 0,
    progress: 0,
    instances: [],
  }
  return processed
}

export const processSourceInstance = (s) => {
  const processed = {
    id: s.id,
    state: s.state || '',
    error: s.error || '',
    sourceId: s.source_id,
    instanceId: s.instance_id,
    instanceName: '',
    active: s.active,
    scPackageId: s.sc_package_extid || '',
    cdnTag: s.sc_cdn_tag || '',
    vastId: s.sc_vast_id || '',
    loading: false,
  }
  return processed
}

export const aepCompToJsonAPI = (comp) => {
  return {
    name: comp.name || comp.comp,
    footage_width: comp.compW,
    footage_height: comp.compH,
    footage_seconds: comp.compDur,
    footage_framerate: comp.compFR,
  }
}

export const aepAssetToJsonAPI = (asset) => {
  return {
    layer: asset.layer,
    name: asset.displayName,
    type: asset.type,
    composition: aepCompToJsonAPI(asset),
    default_value: asset.defaultValue || '',

    label: asset.productionLabel || '',
    mode: asset.productionMode || 'auto_manual',
    auto_value: asset.productionAutoSource || '',
  }
}

export const aepProjectToJsonAPI = (aep) => {
  const processed = {
    id: aep.id,
    extid: aep.name,
    name: aep.name,
    project_url: aep.url,
    root_comp: aepCompToJsonAPI(aep.root),
    assets: [],
    files: aep.files,
    source_url: aep.sourceURL,
    picture_url: aep.pictureURL,
    description: aep.description,
    health_check: aep.health_check,

    is_production: !!aep.isProduction,
    is_active: !!aep.isActive,
    prod_title: aep.productionTitle || '',
    prod_descr: aep.productionDescription || '',
    preview_url: aep.videoURL || '',
    duration: Number(aep.duration || 0),
    prod_type: aep.productionType || '',
    prod_settings: {},
    priority: Number(aep.priority || 0),
  }

  for (let i = 0; i < aep.props.length; i += 1) {
    processed.assets.push(aepAssetToJsonAPI(aep.props[i]))
  }

  return processed
}

const processAEPProjectRoot = (comp) => {
  return {
    name: comp.name,
    compW: comp.footage_width,
    compH: comp.footage_height,
    compDur: comp.footage_seconds,
    compFR: comp.footage_framerate,
  }
}

const processAEPAsset = (asset) => {
  const processed = {
    layer: asset.layer,
    displayName: asset.name,
    type: asset.type,
  }

  const comp = processAEPProjectRoot(asset.composition)

  processed.comp = comp.name
  processed.compW = comp.compW
  processed.compH = comp.compH
  processed.compDur = comp.compDur
  processed.compFR = comp.compFR

  processed.defaultValue = asset.default_value || ''
  processed.file = null
  processed.fileLoading = false

  processed.productionLabel = asset.label || asset.layer
  processed.productionMode = asset.mode || 'auto_manual'
  processed.productionAutoSource = asset.auto_value || ''

  return processed
}

export const processAEPProject = (aep) => {
  const processed = {
    id: aep.id,
    created: aep.create_time,
    name: aep.name,
    url: aep.project_url,
    root: processAEPProjectRoot(aep.root_comp),
    props: [],
    files: aep.files || {},
    pictureURL: aep.picture_url || '',
    sourceURL: aep.source_url || '',
    description: aep.description || '',
    health_check: aep.health_check || false,

    isProduction: !!aep.is_production,
    isActive: !!aep.is_active,
    productionTitle: aep.prod_title || '',
    productionType: aep.prod_type || '',
    productionDescription: aep.prod_descr || '',
    videoURL: aep.preview_url || '',
    duration: Number(aep.duration || 0),
    priority: Number(aep.priority || 0),
  }

  for (let i = 0; i < aep.assets.length; i += 1) {
    processed.props.push(processAEPAsset(aep.assets[i]))
  }

  return processed
}

export const processChannelTemplate = (channelTemplate) => {
  const processed = {
    id: channelTemplate.id || '',
    type: channelTemplate.type || '',
    name: channelTemplate.name || '',
    description: channelTemplate.description || '',
    settings: channelTemplate.settings || '',
    repInterval: channelTemplate.rep_interval || 0,
    default: channelTemplate.default || false,
    aepProjectId: channelTemplate.aep_project_id || 0,
    pictureUrl: channelTemplate.picture_url || '',
    streamUrl: channelTemplate.stream_url || '',
    selected: channelTemplate.selected || false,

    playbackSettings:
    channelTemplate.playback_settings,
  }

  return processed
}
